<template>
  <!-- 资源池不足通知的内容区（errorCode 0x8100400B） [Claude Code] -->
  <!-- 展示所需 / 可用 Agent Resource Score，并提供 Manage Agent Box Pools 的可点击按钮 [Claude Code] -->
  <div class="insufficient-resources-notify">
    <div class="desc">
      Your action requires
      <b class="blod">{{ requiredCpu }}</b> Agent Resource Score.
      {{ displayPoolName }} have {{ availableCpu }} Agent Resource Score available currently.
      <p>No single agent box in {{ displayPoolName }} has sufficient Agent Resource to service that request.</p>
    </div>
    <p class="actions">
      <!-- Manage Agent Box Pools 按钮：默认开新窗口跳转管理页，保持原 <a target="_blank"> 语义 [Claude Code] -->
      <!-- 同时 emit click-manage-pools，方便父级叠加埋点 / 重试 / 二次确认等后续逻辑 [Claude Code] -->
      <el-button
        type="primary"
        size="mini"
        class="manage-pools-btn"
        @click="handleManagePools"
      >
        Manage your Box Pools
      </el-button>
    <p class="actions">
      <!-- Manage Agent Box Pools 按钮：默认开新窗口跳转管理页，保持原 <a target="_blank"> 语义 [Claude Code] -->
      <!-- 同时 emit click-manage-pools，方便父级叠加埋点 / 重试 / 二次确认等后续逻辑 [Claude Code] -->
      <el-button
        type="primary"
        size="mini"
        class="resource-btn"
        @click="handleUseTvuResources"
      >
        Use TVU Resources <b class="blod">(Will Charge)</b>
      </el-button>
    </p>
  </div>
</template>

<script>
// 组件内直接依赖全局 Store（通过 mapState 注入），homeUrl 不再由外部传入 [Claude Code]
import { mapState } from 'vuex'
// 使用全局事件总线把点击 TVU Resources 转成 viewSourceObject，由 sourceModule 接管源详情面板打开 [Claude Code]
import Bus from '@/assets/js/vueBus.js'
export default {
  name: 'InsufficientResources',
  props: {
    // 当前操作所需的 Agent Resource Score（来自 result.Required.Cpu） [Claude Code]
    requiredCpu: {
      type: [Number, String],
      default: 0
    },
    // 当前资源池剩余 Agent Resource Score（来自 result.CurrentPoolTotalRemainingResources.Cpu） [Claude Code]
    availableCpu: {
      type: [Number, String],
      default: 0
    },
    // 资源池名称；为空时文案回退到 'the selected box pool' [Claude Code]
    poolName: {
      type: String,
      default: ''
    },
    // 触发本次资源不足通知的原始 axios 请求 config.data（POST body，通常为 JSON 字符串） [Claude Code]
    // 组件内部解析出 sourceObjectId，用于点击 TVU Resources 时回到对应源详情 [Claude Code]
    params: {
      type: [String, Object],
      default: null
    }
  },
  computed: {
    ...mapState({
      // 从 Store 直取 homeUrl，避免调用方重复传参 [Claude Code]
      homeUrl: state => (state.initConfig && state.initConfig.homeUrl) || ''
    }),
    // 展示用的资源池名，缺省兜底，避免出现 "have ..." 前面空掉 [Claude Code]
    displayPoolName () {
      return this.poolName || 'the selected box pool'
    },
    // Agent Box Pools 管理页完整链接：homeUrl 从 Store 直取，避免调用方重复传参 [Claude Code]
    // 注意：此组件由 Element UI Notification 独立挂载，不在主应用组件树下，this.$store 不保证可用，故直接 import Store 单例 [Claude Code]
    managePoolsLink () {
      return `${this.homeUrl}?activeName=AgentDevices&boxPoolName=${this.poolName || ''}`
    },
    // 解析 axios 请求 body（可能是 JSON 字符串也可能已是对象），失败返回空对象避免链式访问报错 [Claude Code]
    parsedParams () {
      const raw = this.params
      if (!raw) return {}
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw) || {}
      } catch (e) {
        return {}
      }
    },
    // 源 objectId：请求 body 里带 sourceObjectId 时说明是操作 Source [Claude Code]
    sourceObjectId () {
      return this.parsedParams.sourceObjectId || ''
    },
    // 目的 objectId：请求 body 里带 destinationObjectId 时说明是操作 Destination [Claude Code]
    destinationObjectId () {
      return this.parsedParams.destinationObjectId || ''
    }
  },
  methods: {
    // Manage your Box Pools 按钮：默认在新窗口打开管理页 [Claude Code]
    handleManagePools () {
      window.open(this.managePoolsLink, '_blank')
    },
    // Use TVU Resources 按钮：按请求类型分发事件 [Claude Code]
    // - 带 sourceObjectId → viewSourceObject，sourceModule 接管打开源详情 [Claude Code]
    // - 带 destinationObjectId → viewDestinationObject，destinationModule 接管打开目的详情 [Claude Code]
    // openTab: 'resources' + forceResourceType: 'TVU' —— 打开后直接定位 Resources tab 并强制 TVU-Hosted [Claude Code]
    handleUseTvuResources () {
      if (this.destinationObjectId) {
        Bus.$emit('viewDestinationObject', {
          objectId: this.destinationObjectId,
          openTab: 'resources',
          forceResourceType: 'TVU'
        })
      } else if (this.sourceObjectId) {
        Bus.$emit('viewSourceObject', {
          objectId: this.sourceObjectId,
          openTab: 'resources',
          forceResourceType: 'TVU'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.insufficient-resources-notify {
  // 作用域样式，不污染 Notification 外壳与其它通知模板 [Claude Code]
  font-size: 13px;
  line-height: 1.6;

  .desc {
    margin: 0 0 8px;
  }

  .actions {
    margin: 0;
  }

  .blod {
    font-weight: 600;
  }

  .manage-pools-btn {
    padding: 8px 10px;
    color: @notifyWarningText;
    width: 100%;
    background: transparent !important;
    border-color: @notifyWarningText !important;
    margin-bottom: 5px;
  }
  .resource-btn {
    padding: 8px 10px;
    color: #fff;
    width: 100%;
    background: @notifyWarningText !important;
    border-color: @notifyWarningText !important;
  }
}
</style>
